// extracted by mini-css-extract-plugin
export default {"wrap":"Soc_wrap__Pcjoa","chart":"Soc_chart__HvAa-","empty":"Soc_empty__E2ok6"};